import ApplicationAdapter from './application';

export default class BrandDnaReportAdapter extends ApplicationAdapter {
  namespace = 'api/v2/social_listening/brand_dna/reports';

  urlForQuery(query: any, modelName: any): string {
    if (query.adapterOptions && query.adapterOptions.customUrl) {
      return `${this.namespace}${query.adapterOptions.customUrl}`;
    }
    return super.urlForQuery(query, modelName);
  }

  urlForCreateRecord(): string {
    return `${this.namespace}`;
  }

  urlForUpdateRecord(id: string): string {
    return `${this.namespace}/${id}`;
  }

  urlForDeleteRecord(id: string): string {
    return `${this.namespace}/${id}`;
  }
}
